import TermsOfService from '../../components/TermsOfService/TermsOfService';

const TermsOfServicePage = () => <TermsOfService />;

export default TermsOfServicePage;
